import Hls from 'hls.js';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import tailwindConfig from '../../../tailwind.config';

const tabletScreen = tailwindConfig.theme.screens.lg.replace('px', '');

gsap.registerPlugin(ScrollTrigger);

export default function(){
	const video = document.querySelector( '[data-js="growing-video"]' )


	if ( video ) {
		const videoSrc = video.getAttribute('data-source')

		// HLS video
		if (Hls.isSupported()) {
			var hls = new Hls({
				debug: false,
			});

			hls.loadSource(videoSrc);



			hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
				const availableQualities = hls.levels.map(level => level.bitrate);
				//const minBitrateThreshold = 720 * 1024; // Minimum bitrate for 720p (in bits per second)
				const minBitrateThreshold = 480 * 1024; // Minimum bitrate for 480p (in bits per second)
		
				let selectedQualityIndex = -1;
		
				// Find the highest quality level that meets or exceeds the minimum bitrate threshold
				for (let i = availableQualities.length - 1; i >= 0; i--) {
					if (availableQualities[i] >= minBitrateThreshold) {
						selectedQualityIndex = i;
						break;
					}
				}
		
				// If no quality level meets the threshold, select the lowest available quality
				if (selectedQualityIndex === -1) {
					selectedQualityIndex = 0;
				}
		
				// Set the selected quality level
				hls.currentLevel = selectedQualityIndex;
			});




			hls.attachMedia(video);
			hls.on(Hls.Events.MEDIA_ATTACHED, function () {
				video.muted = true;
				video.play();
			});
		}
		// hls.js is not supported on platforms that do not have Media Source Extensions (MSE) enabled.
		// When the browser has built-in HLS support (check using `canPlayType`), we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video element through the `src` property.
		// This is using the built-in support of the plain video element, without using hls.js.
		else if (video.canPlayType('application/vnd.apple.mpegurl')) {
			video.src = videoSrc;
			video.addEventListener('canplay', function () {
				video.play();
			});
		}


		// Grow animation.
		if ( window.innerWidth >= tabletScreen ) {
			const trigger         = document.querySelector( '[data-js="growing-video-trigger"]' )
			let videoParentWidth  = video.parentNode.offsetWidth
			let videoParentHeight = video.parentNode.offsetHeight
	
			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: trigger,
					start: "top top",
					end: () => "+=" + (video.offsetHeight),
					scrub: true,
					pin: true,
					pinSpacer: false,
					//markers: true
				}
			});
	
			tl.fromTo( video, { maskSize: videoParentWidth + 'px ' + videoParentHeight + 'px' }, { maskSize: "200vw 320vh" } )
		} else {
			video.removeAttribute('class' )
			video.parentNode.classList.add( 'relative' )
			video.classList.add( 'fill-image' )
		}
	}
}